import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { FormControl } from 'react-bootstrap'

import FormField from 'internal-components/src/components/Form/FormField'

export default function CompanyDetails({
  errors,
  setAbn,
  setCompanyName,
  setCompanySize,
  signup,
}) {
  return (
    <div className="company-creator">
      <FormField
        bsSize="large"
        controlId="companyName"
        controlLabel="Business Name"
        errors={errors}
        onChange={e => setCompanyName(e.target.value)}
        value={signup.get('companyName') || ''}
      />

      <FormField
        bsSize="large"
        controlId="companySize"
        controlLabel="Business Size"
        errors={errors}
        createDefaultControl={() => <FormControl
          componentClass="select"
          onChange={e => setCompanySize(e.target.value)}
          value={signup.get('companySize') || ''}
        >
          <option key="" value="">Not a business</option>
          <option key="Micro" value="Micro">Micro (1-4 people)</option>
          <option key="Small" value="Small">Small (5-19 people)</option>
          <option key="Medium" value="Medium">Medium (20-199 people)</option>
          <option key="Enterprise" value="Enterprise">Enterprise (200+ people)</option>
          <option key="Government" value="Government">Government</option>
        </FormControl>}
      >
      </FormField>

      <FormField
        bsSize="large"
        controlId="abn"
        controlLabel="ABN"
        errors={errors}
        onChange={e => setAbn(e.target.value)}
        value={signup.get('abn') || ''}
      />
    </div>
  )
}

CompanyDetails.propTypes = {
  errors: Ipt.map.isRequired,
  setAbn: Pt.func.isRequired,
  setCompanyName: Pt.func.isRequired,
  setCompanySize: Pt.func.isRequired,
  signup: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/CompanyDetails.jsx